<template>
  <div>
    <div class="pc_all GenerateManagement LogoFile">
      <div class="GenerateManagementContent ">
        <div class="GenerateManagementContent_nav">
          <div class="GenerateManagementContent_nav_left">
            <div class="nav_left_dd font20">LOGO文件</div>
            <div class="nav_left_dt font14">
              全部原创设计，线上/线下全渠道，皆可商用。支持下载JPG、PNG和SVG源文件等格式
            </div>
          </div>
          <div class="GenerateManagementContent_nav_share">
            分享<img alt="" src="@a/ailogo/images/sv14.svg"/>
          </div>
        </div>
        <div class="GenerateManagementContent_txt">
          <div class="GenerateManagementContent_txt_scroll OScroll">
            <div class="GenerateManagementContent_txt_list">
              <div class="txt_list_top">
                <div class="list_top_li"><img alt="" class="responsive-img" :src="picturesAndTextsWithBackground"/>
                </div>
              </div>
              <div class="txt_list_title">
                <div class="list_title_left">
                  <div class="title_left_dd font16">完整图文LOGO | 纯色背景</div>
                  <div class="title_left_dt font14">实际下载尺寸：1600*900</div>
                </div>
                <div class="list_title_icon">
                  <div class="title_icon_title font16"><img alt="" src="@a/ailogo/images/sv3_1.svg"/>下载</div>
                  <div class="title_icon_down">
                    <div class="icon_down_list font14" @click="downloadImage(picturesAndTextsWithBackground,title)"><img
                        alt="" src="@a/ailogo/img2/png.svg"/>PNG高清文件下载
                    </div>
                    <div>
                      <!-- isSVG 为 false 时显示完整内容 -->
                      <div v-if="!isSVG" class="icon_down_list font14 svg">
                        <div class="down_list_dt">
                          <img alt="" src="@a/ailogo/img2/svg.svg"/>矢量印刷版下载
                        </div>
                        <router-link to="/ailogo/LogoCenter/FreeCreationCenter" class="down_list_dd">
                          先在创作记录转矢量版
                          <img alt="" src="@a/ailogo/images/sv7on.svg"/>
                        </router-link>
                      </div>
                      <!-- isSVG 为 true 时显示简化内容 -->
                      <div v-else class="icon_down_list font14"
                           @click="downloadPicturesAndTextsWithBackground(independentPattern, title)">
                        <div class="down_list_dt">
                          <img alt="" src="@a/ailogo/img2/svg.svg"/>矢量印刷版下载
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="GenerateManagementContent_txt_list">
              <div class="txt_list_top">
                <div class="list_top_li"><img alt="" class="responsive-img" :src="independentPatternWithBackground"/>
                </div>
              </div>
              <div class="txt_list_title">
                <div class="list_title_left">
                  <div class="title_left_dd font16">独立图案LOGO | 纯色背景</div>
                  <div class="title_left_dt font14">实际下载尺寸：1600*900</div>
                </div>
                <div class="list_title_icon">
                  <div class="title_icon_title font16"><img alt="" src="@a/ailogo/images/sv3_1.svg"/>下载</div>
                  <div class="title_icon_down">
                    <div class="icon_down_list font14" @click="downloadImage(independentPatternWithBackground,title)">
                      <img alt="" src="@a/ailogo/img2/png.svg"/>PNG高清文件下载
                    </div>
                    <div>
                      <!-- isSVG 为 false 时显示完整内容 -->
                      <div v-if="!isSVG" class="icon_down_list font14 svg">
                        <div class="down_list_dt">
                          <img alt="" src="@a/ailogo/img2/svg.svg"/>矢量印刷版下载
                        </div>
                        <router-link to="/ailogo/LogoCenter/FreeCreationCenter" class="down_list_dd">
                          先在创作记录转矢量版
                          <img alt="" src="@a/ailogo/images/sv7on.svg"/>
                        </router-link>
                      </div>
                      <!-- isSVG 为 true 时显示简化内容 -->
                      <div v-else class="icon_down_list font14"
                           @click="downIndependentPatternWithBackground(independentPattern, title)">
                        <div class="down_list_dt">
                          <img alt="" src="@a/ailogo/img2/svg.svg"/>矢量印刷版下载
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
            <div class="GenerateManagementContent_txt_list">
              <div class="txt_list_top ">
                <div class="list_top_li grid-bg"><img alt="" :src="picturesAndTexts"/></div>
              </div>
              <div class="txt_list_title">
                <div class="list_title_left">
                  <div class="title_left_dd font16">完整图文LOGO | 透明背景</div>
                  <div class="title_left_dt font14">实际下载尺寸：1600*900</div>
                </div>
                <div class="list_title_icon">
                  <div class="title_icon_title font16"><img alt="" src="@a/ailogo/images/sv3_1.svg"/>下载</div>
                  <div class="title_icon_down">
                    <div class="icon_down_list font14" @click="downloadImage(picturesAndTexts,title)"><img alt=""
                                                                                                           src="@a/ailogo/img2/png.svg"/>PNG高清文件下载
                    </div>

                    <div>
                      <!-- isSVG 为 false 时显示完整内容 -->
                      <div v-if="!isSVG" class="icon_down_list font14 svg">
                        <div class="down_list_dt">
                          <img alt="" src="@a/ailogo/img2/svg.svg"/>矢量印刷版下载
                        </div>
                        <router-link to="/ailogo/LogoCenter/FreeCreationCenter" class="down_list_dd">
                          先在创作记录转矢量版
                          <img alt="" src="@a/ailogo/images/sv7on.svg"/>
                        </router-link>
                      </div>
                      <!-- isSVG 为 true 时显示简化内容 -->
                      <div v-else class="icon_down_list font14"
                           @click="downPicturesAndTexts(independentPattern, title)">
                        <div class="down_list_dt">
                          <img alt="" src="@a/ailogo/img2/svg.svg"/>矢量印刷版下载
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
            <div class="GenerateManagementContent_txt_list">
              <div class="txt_list_top">
                <div class="list_top_li  grid-bg"><img alt="" class="responsive-img" :src="independentPattern"/></div>
              </div>
              <div class="txt_list_title">
                <div class="list_title_left">
                  <div class="title_left_dd font16">独立图案LOGO | 透明背景</div>
                  <div class="title_left_dt font14">实际下载尺寸：1600*900</div>
                </div>
                <div class="list_title_icon">
                  <div class="title_icon_title font16"><img alt="" src="@a/ailogo/images/sv3_1.svg"/>下载</div>
                  <div class="title_icon_down">
                    <div class="icon_down_list font14" @click="downloadImage(independentPattern,title)"><img alt=""
                                                                                                             src="@a/ailogo/img2/png.svg"/>PNG高清文件下载
                    </div>

                    <div>
                      <!-- isSVG 为 false 时显示完整内容 -->
                      <div v-if="!isSVG" class="icon_down_list font14 svg">
                        <div class="down_list_dt">
                          <img alt="" src="@a/ailogo/img2/svg.svg"/>矢量印刷版下载
                        </div>
                        <router-link to="/ailogo/LogoCenter/FreeCreationCenter" class="down_list_dd">
                          先在创作记录转矢量版
                          <img alt="" src="@a/ailogo/images/sv7on.svg"/>
                        </router-link>
                      </div>
                      <!-- isSVG 为 true 时显示简化内容 -->
                      <div v-else class="icon_down_list font14"
                           @click="downloadIndependentPattern(independentPattern, title)">
                        <div class="down_list_dt">
                          <img alt="" src="@a/ailogo/img2/svg.svg"/>矢量印刷版下载
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {fabric} from 'fabric'
import Header from '@c/header/header'
import {svgDownload} from '@/utils/download.js';


export default {
  props: {
    picturesAndTextsWithBackground: null,
    // canvas: null,
    independentPatternWithBackground: null,
    picturesAndTexts: null,
    independentPattern: null,
    svgBaseUrl: null,
    title: null,
    isSVG: false,
    // canvasWidth: 1200,
    // canvasHeight: 900,
  },
  data() {
    return {
      GenerateManagementWindowActive: false,

    }
  },

  components: {
    Header
  },
  async mounted() {


  },
  computed: {},

  methods: {


    downloadImage(base64Data, fileName) {
      const link = document.createElement('a');
      link.href = base64Data;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    async downloadPicturesAndTextsWithBackground(base64Data, fileName) {
      if (this.isSVG) {
        try {
          // 获取原始 SVG 图片的 URL
          const originalSvg = await this.axios.get(this.svgBaseUrl + "/logo.svg", {
            responseType: "text",
            withCredentials: false
          },);
          // 创建一个 Fabric.js Canvas 实例
          const canvas = new fabric.Canvas('canvas');
          // 将原始 SVG 字符串插入到 Fabric.js Canvas 中
          fabric.loadSVGFromString(originalSvg, (objects, options) => {
            // 计算图形的宽度和高度
            const svgWidth = options.width;
            const svgHeight = options.height;
            // 创建一个矩形背景并添加到 Canvas
            const background = new fabric.Rect({
              left: 0,
              top: 0,
              width: svgWidth,
              height: svgHeight,
              fill: '#ffcc00', // 设置背景颜色
              selectable: false // 背景不可选
            });

            // 将背景和 SVG 图形添加到 Canvas
            const svgGroup = fabric.util.groupSVGElements(objects, options);
            canvas.add(background); // 先添加背景
            canvas.add(svgGroup);   // 然后添加 SVG 图形

            // 设置 Canvas 尺寸
            canvas.setWidth(svgWidth);
            canvas.setHeight(svgHeight);

            // 导出带背景的 SVG 图形
            const svgString = canvas.toSVG();
            svgDownload(svgString, fileName);

            // // 创建一个下载链接
            // const link = document.createElement('a');
            // link.href = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgString);
            // link.download = `${fileName}.svg`;  // 设置文件名
            // document.body.appendChild(link);
            // link.click(); // 触发下载
            // document.body.removeChild(link); // 删除链接
          });


        } catch (error) {
          console.error("加载或处理 SVG 图片失败:", error);
        }

      } else {
        //   弹出支付页面
      }

    },
    async downIndependentPatternWithBackground(base64Data, fileName) {
      if (this.isSVG) {
        try {
          // 获取原始 SVG 图片的 URL
          const originalSvg = await this.axios.get(this.svgBaseUrl + "/icon.svg", {
            responseType: "text",
            withCredentials: false
          },);
          // 创建一个 Fabric.js Canvas 实例
          const canvas = new fabric.Canvas('canvas');
          // 将原始 SVG 字符串插入到 Fabric.js Canvas 中
          fabric.loadSVGFromString(originalSvg, (objects, options) => {
            // 计算图形的宽度和高度
            const svgWidth = options.width;
            const svgHeight = options.height;
            // 创建一个矩形背景并添加到 Canvas
            const background = new fabric.Rect({
              left: 0,
              top: 0,
              width: svgWidth,
              height: svgHeight,
              fill: '#ffcc00', // 设置背景颜色
              selectable: false // 背景不可选
            });

            // 将背景和 SVG 图形添加到 Canvas
            const svgGroup = fabric.util.groupSVGElements(objects, options);
            canvas.add(background); // 先添加背景
            canvas.add(svgGroup);   // 然后添加 SVG 图形

            // 设置 Canvas 尺寸
            canvas.setWidth(svgWidth);
            canvas.setHeight(svgHeight);

            // 导出带背景的 SVG 图形
            const svgString = canvas.toSVG();
            svgDownload(svgString, fileName);
            // 创建一个下载链接
            // const link = document.createElement('a');
            // link.href = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgString);
            // link.download =  `${fileName}.svg`;  // 设置文件名
            // document.body.appendChild(link);
            // link.click(); // 触发下载
            // document.body.removeChild(link); // 删除链接
          });


        } catch (error) {
          console.error("加载或处理 SVG 图片失败:", error);
        }

      } else {
        //   弹出支付页面
      }
    },
    async downPicturesAndTexts(base64Data, fileName) {
      if (this.isSVG) {
        try {
          // 获取原始 SVG 图片的 URL
          const originalSvg = await this.axios.get(this.svgBaseUrl + "/logo.svg", {
            responseType: "text",
            withCredentials: false
          },);
          // 创建一个 Fabric.js Canvas 实例
          svgDownload(originalSvg, fileName);
          // 创建一个下载链接
          // const link = document.createElement('a');
          // link.href = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(originalSvg);
          // link.download =  `${fileName}.svg`;  // 设置文件名
          // document.body.appendChild(link);
          // link.click(); // 触发下载
          // document.body.removeChild(link); // 删除链接

        } catch (error) {
          console.error("加载或处理 SVG 图片失败:", error);
        }

      } else {
        //   弹出支付页面
      }
    },
    async downloadIndependentPattern(base64Data, fileName) {
      if (this.isSVG) {
        try {
          // 获取原始 SVG 图片的 URL
          const originalSvg = await this.axios.get(this.svgBaseUrl + "/icon.svg", {
            responseType: "text",
            withCredentials: false
          },);
          // 创建一个 Fabric.js Canvas 实例
          svgDownload(originalSvg, fileName);
          // 创建一个下载链接
          // const link = document.createElement('a');
          // link.href = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(originalSvg);
          // link.download =  `${fileName}.svg`;  // 设置文件名
          // document.body.appendChild(link);
          // link.click(); // 触发下载
          // document.body.removeChild(link); // 删除链接

        } catch (error) {
          console.error("加载或处理 SVG 图片失败:", error);
        }

      } else {
        this.downloadImage(base64Data, fileName + ".png");
      }
    },

  }
}
</script>


<style>
@import "GenerateManagement.css";

.grid-bg {
  background-image: linear-gradient(45deg, rgba(0, 0, 0, .08) 25%, transparent 25%, transparent 75%, rgba(0, 0, 0, .08) 75%), linear-gradient(45deg, rgba(0, 0, 0, .08) 25%, transparent 25%, transparent 75%, rgba(0, 0, 0, .08) 75%);
  background-position: 0 0, 10px 10px;
  background-size: 20px 20px;
}

.responsive-img {
  width: 100%; /* 根据容器宽度自动调整 */
  height: auto; /* 高度自动，保持比例 */
  object-fit: contain; /* 等比例缩放，完整显示图片 */
}
</style>
